import toast from "react-hot-toast";


export default function SentryTestPage() {

    const handleError = () => {
        toast.error('This is your first error!');
        throw new Error('This is your first error!');
    }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-orange-50">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-8">
          🚨 Sentry Test Page 🚨
        </h1>
        <button
          className="group relative px-8 py-4 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold text-lg rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 ease-in-out border-2 border-red-400 hover:border-red-500"
          onClick={handleError}
        >
          <span className="relative z-10 flex items-center gap-2">
            💥 Break the World 💥
          </span>
          <div className="absolute inset-0 bg-gradient-to-r from-red-600 to-red-700 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </button>
        <p className="mt-4 text-gray-600 text-sm">
          ⚠️ Este botón generará un error para probar Sentry
        </p>
      </div>
    </div>
  );
}